import React from 'react';
import "./orderDetailsSection.scss";
import ContactSectionComponent from "../pages/main/sections/contactSection/ContactSectionComponent";
import OrderMainFoodComponent from "./orderMainFoodSection/OrderMainFoodComponent";
import {useParams} from "react-router-dom";

const OrderMainFoodSectionComponent = () => {
    const {category, details} = useParams();

    return (
        <div className="orderMainFoodSection__container">
            <div className="mainSectionComponent__container-content-overlay"></div>
            <OrderMainFoodComponent />
            <ContactSectionComponent />
        </div>
    );
};

export default OrderMainFoodSectionComponent;